import type { TenantStatus } from "@repo/shared";

export function StatusBadge({ status }: { status: TenantStatus }) {
  return (
    <span className={`badge badge--${status}`}>
      {status === "active" ? "aktiv" : "gesperrt"}
    </span>
  );
}
